export default {
    getUser: state => state.user,
    getCams: state => {
        return state.cams.map(cam => ({
            ...cam,
            views: state.views.filter((view, i) => view.cams.indexOf(cam.id) > -1 && i != 0)
        }))
    },
    getCamIdFromCell: state => state.camIdFromCell,
    getViews: state  => {
        return state.views.map(view => {
            return {
                ...view,
                cams: view.cams.map(id => state.cams.find(cam => cam.id == id) || { id: null, name: 'Empty'})
            }
        })
    },
    getActiveView: (state, getters) => {
        return getters.getViews.find(view => view.id == state.route.params.viewId) || null
    },
    getMaps: state => state.maps,
    getMapById: (state) => (groupId, mapId) => {
        let group = state.maps.find(group => group.id == groupId) || null

        if (group) {
            let map = group.map.find(map => map.id == mapId)

            if (map) {
                let cams = map.objects.filter(item => item.type == 'CAM').map(cam => {
                    cam.open = false

                    return {
                        ...cam,
                        ...state.cams.find(c => c.id == cam.id),
                    }
                })

                let levels = map.objects.filter(item => item.type == 'LEVEL').map(item => {
                    return { ...item, mapId: group.map.find(m => m.name == item.id).id }
                })

                const mapObjs = map.objects.filter(item => item.type !== 'LEVEL' && item.type !== 'CAM')

                return {
                    ...map,
                    cams,
                    levels,
                    mapObjs
                }
            }

            return null
        }

        return null
    },
    getAlarmCams: (state, getters) => {
         return getters.getCams.filter(cam => {
            return ['DISARM_DETACHED', 'DETACHED', 'ALARMED'].includes(cam.status.state) ||
                    cam.status.valid === false ||
                    cam.status.focused === "false" ||
                    cam.status.unblinded === "false"

        })
    },
    getAlarmMaps: (state, getters) => {
        const alarmsCams = getters.getAlarmCams
        let filterGroup = getters.getMaps.filter(group => {
            let isAlarm = false
            for (let i=0; i < group.map.length; i++) {
                if (isAlarm) {
                    break
                }
                const mapObj = group.map[i]
                for (let j=0; j < mapObj.objects.length; j++) {
                    const camObj = mapObj.objects[j]
                    if (!!alarmsCams.find(ac => ac.id === camObj.id)) {
                        isAlarm = true
                        break
                    }
                }
            }
            return isAlarm
        })
        
        if (filterGroup.length) {
            filterGroup = filterGroup.map(group => {
                return {
                    ...group,
                    map: group.map.map(mapObj => {
                        return {
                            ...mapObj,
                            objects: mapObj.objects.filter(camObj => {
                                return !!alarmsCams.find(ac => ac.id === camObj.id)
                            })
                        }
                    })
                }
            })
            filterGroup = filterGroup.map(group => {
                return {
                    ...group,
                    map:  group.map.filter(mapObj => {
                        return !!mapObj.objects.length
                    })
                }
            })
            return filterGroup
        }
        
        return []
    },
    getActiveMap: (state, getters) => {
        return getters.getMapById(state.route.params.mapGroupId, state.route.params.mapId) || null
    },
    getAlarmViews: state => state.views.slice(1),
    getAlarms: state => state.alarms,
    getLatestAlarms: state => state.alarms.slice(0, 6),
    getAlarmsActiveView: state => {
        if (state.route.query && state.route.query.view) {
            return state.views.find(view => view.id == state.route.query.view) || null
        }

        return null
    },
    getMode: state => state.mode,
    getGrids: state => state.grids,
    getActiveGrid: state => state.grids.find(grid => grid.value == state.grid) || null,
    getGrid: state => state.grid,
    getStream: state => state.stream,
    getUplodedVideos: state => state.uploadedVideos,
    getVideoState: state => state.videoState,
    getArchCnvEnabled: state => state.archCnvEnabled
}



// WEBPACK FOOTER //
// ./src/store/getters.js